 <template>
  <div class="team">
    <!-- 缺省 -->
    <div v-if="!team_list.length" class="empty">
      <Empty
        emptyType="team"
        emptyText="抱歉，您当前还没有创建/参与任何团队"
        emptyTips="组建团队打造专属资源库，整合优势、共享行业资源，一起在时尚赛道抢占先机！"
      ></Empty>
      <div @click="show_create_team = true" class="create-team">
        立即创建我的团队
      </div>
    </div>
    <!-- 团队资源 -->
    <div v-else class="team-container">
      <div class="team-top">
        <div class="top-left">
          <img :src="curr_team.image | default_team_logo" alt="" class="team-logo" />
          <div class="team-info">
            <div class="team-name-box">
              <div class="team-name">{{curr_team.name}}</div>
              <div class="team-tag">{{curr_team.role}}</div>
              <Poptip placement="bottom-end" trigger="hover" :offset="20">
                <template #content>
                  <div class="team-list-container">
                    <div class="list-top">
                      <div
                        class="list-item"
                        v-for="(item, index) in team_list"
                        :key="index" @click="onTeamSelect(item)"
                      >
                        <div class="item-team">
                          <img
                            :src="item.image |  default_team_logo"
                            alt=""
                            class="item-team-logo"
                          />
                          <div class="item-team-info">
                            <div class="item-team-name-box">
                              <div class="team-name">{{ item.name }}</div>
                              <div class="item-team-tag">{{item.role}}</div>
                            </div>
                            <div class="item-team-desc">{{item.description}}</div>
                          </div>
                        </div>
                        <Icon
                          v-if="item.id === curr_team.id"
                          type="md-checkmark"
                          class="item-selected"
                        />
                        <div class="item-more">
                          <Poptip
                            placement="bottom-start"
                            trigger="hover"
                            :offset="0"
                          >
                            <template #content>
                              <div class="more-list">
                                <div :class="['more-item',{disabled:item.role==='所有者'}]" @click.stop="onQuitTeam(item)">退出团队</div>
                              </div>
                            </template>
                            <Icon type="ios-more" size="22" />
                          </Poptip>
                        </div>
                      </div>
                    </div>
                    <div class="list-bottom" v-if="!hasOwnTeam">
                      <div class="bottom-btn" @click="show_create_team = true">
                        <Icon type="md-add" /> 创建新团队
                      </div>
                    </div>
                  </div>
                </template>
                <Icon type="ios-arrow-down" size="16" />
              </Poptip>
            </div>
            <div class="team-desc">
              {{curr_team.description}}
            </div>
          </div>
        </div>
        <div class="top-right">
          <input type="text" v-model="keyword" @keyup.enter="onGetTeamFolderFileList(in_root ? '' : curr_folder.uuid)" placeholder="搜索资源库文件或文件夹" />
          <Icon type="ios-search" size="20" @click="onGetTeamFolderFileList(in_root ? '' : curr_folder.uuid)" />
        </div>
      </div>
      <div class="team-menu">
        <div class="menu-tabs" v-if="in_root">
          <div
            @click="onChangeTab('files')"
            :class="['menu-item', { active: curr_tab == 'files' }]"
          >
            团队资源
          </div>
          <div
            @click="onChangeTab('members')"
            :class="['menu-item', { active: curr_tab == 'members' }]"
          >
            团队成员
          </div>
          <div v-if="curr_team.role === '所有者'"
            @click="onChangeTab('settings')"
            :class="['menu-item', { active: curr_tab == 'settings' }]"
          >
            设置
          </div>
        </div>
        <div v-else class="bread-crumb">
          <bread-crumb
          :crumbs="breadCrumbs" :maxItems="3"
          @item-click="handleBreadcrumbClick"
          @expand="handleExpand" />
        </div>
        <div class="menu-actions">
          <!--  -->
          <div v-if="['files','members'].includes(curr_tab) && userInfo.id == curr_team.user_id" :class="['add-member',{'members-style':curr_tab=='members'}]" @click="show_member_add = true">
            <img :src="curr_tab == 'members' ? require('@/assets/images/team/icon-team-invite-white.png'):require('@/assets/images/team/icon-team-invite.png')" /> {{curr_tab == 'files' ? '邀请' :'添加'}}成员
          </div>
          <Poptip
            v-if="curr_tab == 'files'"
            placement="bottom-end"
            trigger="hover"
            :offset="0"
          >
            <template #content>
              <div class="add-menu-list">
                <Upload
                    action="/"
                    :data="{ dir: 'template' }"
                    :before-upload="
                    (file) =>
                        onUploadFile(file)
                    "
                    :show-upload-list="false" class="add-menu-item"
                >
                  <div class="up-file-btn">上传文件</div>
                </Upload>
                <div class="add-menu-item" v-if="[1,2,3,51,52,53].includes(Number(curr_folder.type))" @click="onFileImport">从[我的历史记录]导入</div>
                <div class="add-menu-item" @click="show_create_folder = true">新建文件夹</div>
              </div>
            </template>
            <div class="add-file"><Icon type="md-add" size="16" />添加文件</div>
          </Poptip>
        </div>
      </div>
      <template v-if="curr_tab == 'files'">
        <div v-if="in_root || folderList.length > 0" class="team-folder-title">
          文件夹({{ folderList.length || 0 }})
        </div>
        <div class="team-folder-list">
          <div
            class="team-folder-item"
            v-for="(item, index) in folderList"
            :key="index"
            @click.stop="onFolderClick(item)"
          >
            <div class="folder-actions">
              <Poptip v-if="item.is_default != 1" placement="bottom-start" trigger="hover">
                <template #content>
                  <div class="folder-action-menu">
                    <div class="folder-action-item" @click.stop="onFolderRename(item)">
                      <img
                        src="@/assets/images/team/icon-team-file-edit.png"
                        alt=""
                        class="folder-action-icon"
                      />重命名
                    </div>
                    <div class="folder-action-item" @click.stop="onFolderDelete(item)">
                      <img
                        src="@/assets/images/team/icon-team-file-delete.png"
                        alt=""
                        class="folder-action-icon"
                      />删除
                    </div>
                    <Poptip placement="right" trigger="hover">
                      <template #content>
                        <div class="folder-action-menu">
                          <div class="folder-action-item" @click.stop="onFolderPermission(item,'1')">
                            <Icon
                              v-show="item.is_visible == 1"
                              type="md-checkmark"
                              class="item-selected"
                            />公开可见
                          </div>
                          <div class="folder-action-item" @click.stop="onFolderPermission(item,'0')">
                            <Icon
                              v-show="item.is_visible != 1"
                              type="md-checkmark"
                              class="item-selected"
                            />仅自己可见
                          </div>
                        </div>
                      </template>
                      <div class="folder-action-item" @click.stop>
                        <img
                          src="@/assets/images/team/icon-team-permission.png"
                          alt=""
                          class="folder-action-icon"
                        />权限设置
                      </div>
                    </Poptip>
                  </div>
                </template>
                <Icon type="ios-more" size="22" />
              </Poptip>
            </div>
            <div class="folder-container">
              <img
                src="@/assets/images/team/icon-team-folder.png"
                alt=""
                class="folder-icon"
              />
              <div class="folder-info">
                <div class="folder-name">{{ item.name }}</div>
                <div class="folder-count">{{ item.file_count || 0 }}个内容</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="in_root || fileList.length > 0" class="team-resource-title">
          其它资源({{ fileList.length || 0 }})
        </div>
        <template v-if="!fileList.length">
          <Empty
            emptyType="folder"
            emptyText="暂无内容"
            :showTips="!in_root"
            emptyTips="点击添加或从[我的历史记录]导入数据,团队成员可共享"
            :marginTop="80"
          />
          <div v-if="!in_root" class="folder-empty-btn">
            <Upload
              action="/"
              :data="{ dir: 'template' }"
              :before-upload="
              (file) =>
                  onUploadFile(file)
              "
              :show-upload-list="false"
            >
              <div class="folder-files-add-btn"><Icon type="md-add" /> 添加</div>
            </Upload>

            <div class="import-btn" v-if="[1,2,3,51,52,53].includes(Number(curr_folder.type))" @click="onFileImport">从[我的历史记录]导入</div>
          </div>
        </template>
        <div v-else class="team-resource-list">
          <div class="file-item" v-for="(item,index) in fileList" :key="index" @click="onFileClick(item)">
            <div class="icon-cover-box">
              <img v-if="(item.path && util.test_image(item.path))" :src="item.path" class="cover-img" alt="" />
              <img v-else-if="(item.info && util.test_image(item.info.image))" :src="item.info.image" class="cover-img" alt="" />
              <img v-else :src="util.get_image_icon(item.path)" class="cover-icon" />
              <div class="file-more">
                <Poptip placement="bottom-start" trigger="hover">
                  <template #content>
                    <div class="more-action-menu">
                      <div class="action-item" v-if="!in_root && [1,2,3,51,52,53].includes(Number(curr_folder.type))" @click.stop="onCreateDesign(item)">
                        <img src="@/assets/images/team/icon-team-style-design.png" alt="" class="action-icon" />
                        创建款式设计
                      </div>
                      <div v-if="onShowDownload(item)" class="action-item" @click.stop="onFileDownload(item)">
                        <img
                          src="@/assets/images/team/icon-team-file-download.png"
                          alt=""
                          class="action-icon"
                        />下载
                      </div>
                      <div class="action-item" style="margin-right: 20px" @click.stop="onFileRemove(item)">
                        <img
                          src="@/assets/images/team/icon-team-file-move.png"
                          alt=""
                          class="action-icon"
                        />移动到文件夹
                      </div>
                      <div class="action-item" @click.stop="onFileRename(item)">
                        <img
                          src="@/assets/images/team/icon-team-file-edit.png"
                          alt=""
                          class="action-icon"
                        />重命名
                      </div>
                      <div class="action-item" @click.stop="onFileDelete(item)">
                        <img
                          src="@/assets/images/team/icon-team-file-delete.png"
                          alt=""
                          class="action-icon"
                        />删除
                      </div>
                    </div>
                  </template>
                  <div class="more-btn"></div>
                </Poptip>
              </div>
            </div>
            <div class="file-name">{{item.name}}</div>
          </div>
        </div>
      </template>
      <template v-if="curr_tab == 'members'">
        <div class="member-top">
          <div class="member-title">全部成员({{member_list.length || 0}})</div>
          <div class="member-search">
            <input type="text" placeholder="搜索成员" v-model="member_keyword" @keyup.enter="onGetTeamMemberList" />
            <Icon type="ios-search" class="cursor" size="22" @click="onGetTeamMemberList" />
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>成员信息</th>
              <th>加入时间</th>
              <th>团队角色</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!member_list.length">
              <tr>
                <td colspan="4">
                  <empty
                    emptyType="member"
                    marginTop="5%"
                    emptyText="暂无成员"
                    :showTips="false"
                  ></empty>
                </td>
              </tr>
            </template>
            <template v-else>
                <tr class="data-tr" v-for="(item,index) in member_list" :key="index">
                    <td>
                        <div class="member-info">
                            <img :src="item.avatar|default_img" alt="" class="member-avatar">
                            <div class="member-nick-mobile">
                                <div class="member-nick">
                                    {{item.name_alias || item.nickname}} <div v-if="item.user_id == userInfo.id" class="owner-tag">我</div>
                                </div>
                                <div class="member-mobile">
                                    {{ item.mobile | phone_format }}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>{{ item.create_time | date_format }}</td>
                    <td>{{ item.role }}</td>
                    <td>
                        <template v-if="item.owner_id != userInfo.id">-</template>
                        <template v-else>
                            <div class="operation-col">
                                <template v-if="item.owner_id === userInfo.id && item.user_id != userInfo.id">
                                    <div class="btn" @click="onMemberRemove(item.user_id)">
                                        <img src="@/assets/images/team/icon-team-remove.png" alt="" class="btn-icon"> 移出团队
                                    </div>
                                    <div class="line">|</div>
                                </template>
                                <div class="btn" @click="onMemberAlias(item)">
                                    <img src="@/assets/images/team/icon-team-member-edit.png" alt="" class="btn-icon">修改备注名
                                </div>
                                 <div class="btn chat" @click="onMemberChat(item)">
                                  <div class="chat-icon"></div>
                                  <span>私信</span>
                                </div>
                            </div>
                        </template>
                    </td>
                </tr>
            </template>
          </tbody>
        </table>
      </template>
      <template v-if="curr_tab == 'settings'">
        <div class="team-settings">
            <Form class="create-form">
                <FormItem label="团队名称">
                    <template #label>
                        <div class="label">团队名称</div>
                    </template>
                    <Input size="large" v-model="setting_form.name" placeholder="请输入团队名称" @on-blur="onUpdateTeam"></Input>
                </FormItem>
                <FormItem label="团队头像(可选)">
                    <template #label>
                        <div class="label">团队头像(可选)</div>
                    </template>
                    <div class="upload-team-logo">
                        <img :src="setting_form.image | default_team_logo" alt="" class="logo-container">
                        <div class="upload-btn">
                            <Upload
                                action="/"
                                :data="{ dir: 'template' }"
                                :before-upload="
                                (file) =>
                                    onUploadTeamLogo(file)
                                "
                                :show-upload-list="false"
                            >
                                <div class="btn">上传团队头像</div>
                            </Upload>
                            <div class="tips">支持2M以内的JPG、JPEG、PNG</div>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="团队描述">
                    <template #label>
                        <div class="label">团队描述(可选)</div>
                    </template>
                    <Input type="textarea" :rows="5" size="large" v-model="setting_form.description" placeholder="请输入团队描述" @on-blur="onUpdateTeam"></Input>
                </FormItem>
            </Form>
            <div class="btn-box">
                <div class="btn-label">解散团队</div>
                <div class="confirm-btn" @click="onDisbandTeam">解散团队</div>
                <div class="btn-desc">解散后,团队内所有内容都会被彻底删除不可恢复,请谨慎操作</div>
            </div>
        </div>
      </template>
    </div>
    <!-- 创建团队 -->
    <create-team
      ref="createTeamPop"
      v-if="show_create_team"
      @on-close="onCreateClose"
    />
    <!-- 添加版型 -->
    <pattern-form
      ref="patternFormPop"
      :file="temp_file"
      :teamId="curr_team.uuid"
      :folderId="curr_folder.uuid"
      :isView="is_view"
      :viewInfo="view_info"
      v-if="show_pattern_form"
      @on-success="onGetTeamFolderFileList(in_root ? '' : curr_folder.uuid)"
      @on-close="show_pattern_form = false"
    />
    <!-- 添加面料 -->
    <fabric-form
      ref="fabricFormPop"
      :file="temp_file"
      :teamId="curr_team.uuid"
      :folderId="curr_folder.uuid"
      :isView="is_view"
      :viewInfo="view_info"
      v-if="show_fabric_form"
      @on-success="onGetTeamFolderFileList(in_root?'':curr_folder.uuid)"
      @on-close="()=>{
        show_fabric_form = false;
        is_view = false;
        view_info = {}
      }"
    />
    <!-- 添加辅料 -->
    <accessory-form
      ref="accessoryFormPop"
      :file="temp_file"
      :teamId="curr_team.uuid"
      :folderId="curr_folder.uuid"
      :isView="is_view"
      :viewInfo="view_info"
      v-if="show_accessory_form"
      @on-success="onGetTeamFolderFileList(in_root?'':curr_folder.uuid)"
      @on-close="()=>{
        show_accessory_form = false;
        is_view = false;
        view_info = {}
      }"
    />
    <!-- 平台版型详情 -->
    <pattern-detail
      ref="patternDetailPop"
      v-if="show_pattern_detail"
      :pattern="current_pattern"
      @on-close="show_pattern_detail = false"
    />
    <!-- 平台面料详情 -->
    <fabric-detail
      ref="fabricDetailPop"
      v-if="show_fabric_detail"
      :fabric="current_fabric"
      @on-close="show_fabric_detail = false"
    />
    <!-- 平台辅料详情 -->
    <accessory-detail
      ref="accessoryDetailPop"
      v-if="show_accessory_detail"
      :accessory="current_accessory"
      @on-close="show_accessory_detail = false"
    />
    <!-- 添加成员 -->
    <member-add
      ref="memberAddPop"
      v-if="show_member_add"
      :teamId="curr_team.uuid"
      @on-invite-success="onGetTeamMemberList"
      @on-close="show_member_add = false"
    />
    <!-- 修改备注 -->
    <member-alias
        ref="memberAliasPop"
        v-if="show_member_alias"
        :nickName="current_member_alias"
        :memberId="current_member_id"
        :teamId="curr_team.uuid"
        @on-edit-success="onGetTeamMemberList"
        @on-close="show_member_alias = false"
    />
    <!-- 移除成员 -->
    <remove-member
      ref="removeMemberPop"
      v-if="show_remove_member"
      :memberId="current_member_id"
      :teamId="curr_team.uuid"
      @on-remove="onGetTeamMemberList"
      @on-close="show_remove_member = false"
    />
    <!-- 解散团队 -->
    <team-disband
      ref="teamDisbandPop"
      :teamId="curr_team.uuid"
      v-if="show_team_disband"
      @on-close="show_team_disband = false"
      @on-disband-success="onDisbandSuccess"
    />
    <!-- 新建文件夹 -->
    <create-folder
      ref="createFolderPop"
      :teamId="curr_team.uuid"
      :directoryId="in_root && !is_folder_edit ? '' : curr_folder.uuid"
      :renameFolderId="is_folder_edit ? temp_folder.uuid : ''"
      :folderName="temp_folder.name"
      :isRename="is_folder_edit"
      :currPermission="temp_folder.is_visible"
      v-if="show_create_folder"
      @on-create-folder="onGetTeamFolderFileList(in_root?'':curr_folder.uuid)"
      @on-close="onCreateFolderClose"
    />
    <!-- 移动文件 -->
    <!-- :folders="folderList" -->
    <move-file
      ref="moveFilePop"
      :file="curr_file"
      :teamId="curr_team.uuid"
      v-if="show_move_file"
      @show-form="onShowForm"
      @on-move-success="onGetTeamFolderFileList(in_root?'':curr_folder.uuid)"
      @on-close="show_move_file=false"
    />
    <!-- 文件重命名 -->
    <file-rename
      :teamId="curr_team.uuid"
      :fileInfo="curr_file"
      v-if="show_file_rename"
      @on-close="show_file_rename=false"
      @on-file-rename="onGetTeamFolderFileList(in_root?'':curr_folder.uuid)"
    />
    <chat ref="chat"></chat>
  </div>
</template>
<script>
import {
  quitTeam,
  teamFileCreate,
  teamFileDelete,
  teamFileDetail,
  teamFileImport,
  teamFolderDelete,
  teamFolderFileList,
  teamFolderUpdate,
  teamList,
  teamMemberList,
  updateTeam
} from '@/api/index';
import Empty from "@/components/Empty.vue";
import { uploadFileToOSS } from "@/utils/oss";
import util from '@/utils/util';
import { mapState } from 'vuex';
import AccessoryDetail from "./Components/AccessoryDetail.vue";
import AccessoryForm from "./Components/AccessoryForm.vue";
import BreadCrumb from './Components/BreadCrumb.vue';
import CreateFolder from "./Components/CreateFolder.vue";
import CreateTeam from "./Components/CreateTeam.vue";
import FabricDetail from "./Components/FabricDetail.vue";
import FabricForm from "./Components/FabricForm.vue";
import FileRename from './Components/FileRename.vue';
import MemberAdd from './Components/MemberAdd.vue';
import MemberAlias from './Components/MemberAlias.vue';
import MoveFile from './Components/MoveFile.vue';
import PatternDetail from "./Components/PatternDetail.vue";
import PatternForm from "./Components/PatternForm.vue";
import RemoveMember from './Components/RemoveMember.vue';
import TeamDisband from './Components/TeamDisband.vue';

export default {
  components: {
    Empty,
    CreateTeam,
    PatternForm,
    FabricForm,
    AccessoryForm,
    PatternDetail,
    FabricDetail,
    AccessoryDetail,
    MemberAdd,
    MemberAlias,
    RemoveMember,
    TeamDisband,
    CreateFolder,
    MoveFile,
    FileRename,
    BreadCrumb
  },
  data() {
    return {
      util,
      show_create_team: false,
      show_pattern_form: false,
      show_fabric_form: false,
      show_accessory_form: false,
      show_pattern_detail: false,
      show_fabric_detail: false,
      show_accessory_detail: false,
      show_member_add:false,
      show_member_alias:false,
      show_remove_member:false,
      show_team_disband:false,
      show_create_folder:false,
      show_move_file:false,
      show_file_rename:false,
      in_root: true,
      is_folder_edit:false,
      curr_tab: "files",
      // file_list: [],
      member_list: [],
      team_list:[],
      folder_list: [],
      keyword: '',
      curr_team:{},
      curr_folder: {},
      curr_file:{},
      current_pattern: {},
      current_fabric: {},
      current_accessory: {},
      current_member_alias:'',
      current_member_id:'',
      setting_form:{
        uuid:'',
        name:'',
        image:'',
        description:''
      },
      member_keyword:'',
      temp_file:{},
      temp_folder:{},
      is_view:false,
      view_info:{}
    };
  },
  computed:{
    ...mapState({
        userInfo:state=>state.userInfo,
        breadCrumbs:state=>state.breadCrumbs
    }),
    hasOwnTeam(){
        const {team_list} = this;
        return team_list.filter((item)=>item.role === '所有者').length>0;
    },
    folderList(){
      return this.folder_list.filter((item)=>{
          // 如果是文件夹
          if (item.is_dir) {
            // 如果 is_visible == 1，所有人都能看到
            if (item.is_visible == 1) {
              return true;
            }
            // 如果 is_visible == 0，只有创建者才能看到
            if (item.is_visible == 0 && (item.creator_id == this.userInfo.id || this.userInfo.id == this.curr_team.user_id)) {
              return true;
            }
            return false;
          }
          return false; // 不是文件夹，返回 false
      });
    },
    fileList(){
      return this.folder_list.filter((item)=>!item.is_dir);
    }
  },
  async mounted() {
    await this.onGetTeamList();
    console.log('this.curr_team',this.curr_team);
    if(!this.curr_team || !this.curr_team.uuid) return;
    Promise.all([
        this.onGetTeamFolderFileList()
    ])
  },
  methods: {
    onDisbandSuccess(){
      this.curr_tab = 'files';
      this.onGetTeamList();
    },
    onCreateFolderClose(){
      this.show_create_folder = false
      this.is_folder_edit = false;
    },
    async onFolderPermission(folder,permission){
      try{
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.directory_uuid = folder.uuid;
        param.is_visible = permission;
        param.name = folder.name;
        const {code,msg} = await teamFolderUpdate(param);
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg('权限设置成功~');
        this.onGetTeamFolderFileList(this.in_root?'':this.curr_folder.uuid);
      }catch(e){
        console.log('err-folder-permission',e);
        this.$layer.msg(e.msg);
      }
    },
    async onCreateDesign(file){
      try{
        console.log('file-create-design',file);
         const {type,info,uuid} = file;
        switch(Number(type)){
          case 51:{
            if(file.info.pattern_id){
              const {pattern_id} = info;
              const param = {};
              param.team_uuid = this.curr_team.uuid;
              param.file_id = pattern_id;
              param.file_uuid = uuid;
              param.type = '51';
              const {code,msg,data} = await teamFileDetail(param);
              if(code>0){
                this.$layer.msg(msg);
                return;
              }
              this.$router.push({name:'WorkBenchDesign',params:{file:{...data,type:'51',...file.info}}})
            }else{
              console.log('客供版型处理');
              this.$router.push({name:'WorkBenchDesign',params:{file:{...file.info,id:file.id,type:'51'}}});
            }
            break;
          }
          case 52:{
            console.log('面料文件',file);
            const {fabric_key} = info;
            const param = {};
            param.team_uuid = this.curr_team.uuid;
            param.file_id = fabric_key;
            param.file_uuid = uuid;
            param.type = '52';
            const {code,msg,data} = await teamFileDetail(param);
            console.log('data-fabric',data);
            console.log('code',code);
            if(code === 999){
              this.$router.push({name:'WorkBenchDesign',params:{file:{...file.info,type:'52'}}});
              return;
            }
            if(code>0){
              this.$layer.msg(msg);
              return;
            }
            this.$router.push({name:'WorkBenchDesign',params:{file:{...data,type:'52',...file.info}}})
            break;
          }
          case 53:{
            console.log('辅料文件',file);
            const {accessory_sku} = info;
            const param = {};
            param.team_uuid = this.curr_team.uuid;
            param.file_id = accessory_sku;
            param.file_uuid = uuid;
            param.type = '53';
            const {code,msg,data} = await teamFileDetail(param);
            if(code === 999){
              this.$router.push({name:'WorkBenchDesign',params:{file:{...file.info,type:'53'}}});
              return;
            }
            if(code>0){
              this.$layer.msg(msg);
              return;
            }
            this.$router.push({name:'WorkBenchDesign',params:{file:{...data,type:'53',...file.info}}})
            break;
          }
        }
      }catch(e){
        console.log('file-create-design-error',e);
        this.$layer.msg(e.msg);
      }
    },
    async onFileClick(file){
      const {type,info,uuid} = file;
      console.log('info---->',info);
      if(type == '51'){
        //>版型
        const {pattern_id} = info;
        if(pattern_id){
          const param = {};
          param.team_uuid = this.curr_team.uuid;
          param.file_id = pattern_id;
          param.file_uuid = uuid;
          param.type = '51';
          param.id = info.relate_id;
          const {code,msg,data} = await teamFileDetail(param);
          if(code>0){
            this.$layer.msg(msg);
            return;
          }
          console.log('data-file-detail',data);
          this.current_pattern = data;
        }else{
          console.log('客供版型处理',info);
          this.current_pattern = info;
        }
        this.show_pattern_detail = true;
        return;
      }
      if(type == '52'){
        //>面料
        // console.log('面料文件',info);
        const {key} = info;
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.file_id = key;
        param.file_uuid = uuid;
        param.type = '52';
        param.id = info.relate_id;
        const {code,msg,data} = await teamFileDetail(param);
        if(code === 999){
          this.is_view = true;
          this.view_info = info;
          this.show_fabric_form = true;
          // this.$layer.msg('仅平台面料可预览');

          return;
        }
        
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        console.log('data-file-detail',data);
        this.current_fabric = data;
        this.show_fabric_detail = true;
        return;
      }
      if(type == '53'){
        //>辅料
        console.log('辅料文件',info);
        const {key} = info;
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.file_id = key;
        param.file_uuid = uuid;
        param.type = '53';
        param.id = info.relate_id;
        const {code,msg,data} = await teamFileDetail(param);
        if(code === 999){
          this.is_view = true;
          this.view_info = info;
          this.show_accessory_form = true;
          return;
        }
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        console.log('data-file-detail',data);
        this.current_accessory = data;
        this.show_accessory_detail = true;
        return;
      }
    },
    onShowDownload(file){
      if(file.info.pattern_type || file.info.from_import){
        return false;
      }
      return true;
    },
    async onFileImport(){
      try{
        let type;
        switch(Number(this.curr_folder.type)){
          case 1:
          case 51:
            type = 51;
            break;
          case 2:
          case 52:
            type = 52;
            break;
          case 3:
          case 53:
            type = 53;
            break;
        }
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.type = type;
        console.log('param',param);
        // return;
        const {code,msg} = await teamFileImport(param);
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg('操作成功~');
        if(this.curr_folder){
          this.onGetTeamFolderFileList(this.curr_folder.uuid);
        }else{
          this.onGetTeamFolderFileList();
        }
      }catch(e){
        console.log('err-import-history',e);
        this.$layer.msg(e.msg);
      }
    },
    handleBreadcrumbClick(item, index) {
      // 处理面包屑点击事件
      console.log('点击了:', item, '索引:', index);
      this.onFolderClick(item);
    },
    handleExpand() {
      // 处理展开事件
      console.log('用户点击了省略号');
    },
    onShowForm(param){
      console.log('show-form-param',param);
      const {type,folder} = param;
      console.log('folder--->',folder);
      this.temp_file.folder_uuid = folder.uuid;
      switch(Number(type)){
        case 1:
          this.show_pattern_form = true;
          break;
        case 2:
          this.show_fabric_form = true;
          break;
        case 3:
          this.show_accessory_form = true;
          break;
      }
      this.show_move_file = false;
    },
    onFileRemove(file){
      console.log('file->remove',file);
      this.curr_file = file;
      // this.temp_file = file;
      this.temp_file = {
        name:file.name,
        path:file.path,
        file_uuid:file.uuid,
        file_type:file.type,
        is_move:true
      }
      this.show_move_file = true;
    },
    async onFileDownload(file) {
      try {
        // 发起请求获取文件
        const response = await fetch(file.path);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // 获取文件blob
        const blob = await response.blob();

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // 设置文件名
        if (file.name) {
          link.download = file.name;
        } else {
          // 从URL中提取文件名
          link.download = file.path.split('/').pop().split('?')[0] || 'download';
        }

        // 隐藏链接并添加到文档中
        link.style.display = 'none';
        document.body.appendChild(link);

        // 触发下载
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载文件时出错:', error);
        this.$layer.msg('下载失败，请稍后重试');
      }
    },
    onFileDelete(file){
      const {curr_team,userInfo} = this;
      if(curr_team.user_id != userInfo.id && file.creator_id != userInfo.id){
        this.$layer.msg('您没有权限删除该文件');
        return;
      }
      this.$DModal.confirm({
        content: '是否删除该文件？',
        onOK: async () => {
          try{
            const param = {};
            param.team_uuid = this.curr_team.uuid;
            param.file_uuid = file.uuid;
            const {code,msg} = await teamFileDelete(param);
            if(code>0){
              this.$layer.msg(msg);
              return;
            }
            this.$layer.msg('操作成功~');
            this.onGetTeamFolderFileList(this.in_root?'':this.curr_folder.uuid);
          }catch(e){
            console.log('delete-file-err',e);
            this.$layer.msg(e.msg || JSON.stringify(e));
          }
        }
      })
    },
    onFileRename(file){
      this.curr_file = file;
      this.show_file_rename = true;
    },
    async onUploadFile(file){
      try{
        const url = await uploadFileToOSS(file, 'team/file');
        if(!url){
          this.$layer.msg('上传失败,请重试');
          return;
        }
        let file_type;
        this.temp_file = {name:file.name,path:url};
        switch(Number(this.curr_folder.type)){
          case 51:
          case 1:   //>版型
            file_type = 51;
            this.temp_file.file_type = file_type;
            this.show_pattern_form = true;
            break;
          case 52:
          case 2:   //>面料
            file_type = 52;
            this.temp_file.file_type = file_type;
            this.show_fabric_form = true;
            break;
          case 53:
          case 3:   //>辅料
            file_type = 53;
            this.temp_file.file_type = file_type;
            this.show_accessory_form = true;
            break;
          default:
            file_type = 54;
            this.onCreateNormalFile(file_type,file.name,url);
            break;  //>普通文件
        }
      }catch(e){
        console.log('err-upload-file',e);
        this.$layer.msg(e.msg);
      }
    },
    async onCreateNormalFile(fileType,fileName,url){
      try{
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.directory_uuid = this.in_root?'':this.curr_folder.uuid;
        param.type = fileType;
        param.info = {name:fileName,path:url};
        const {code,msg} = await teamFileCreate(param);
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg('操作成功~');
        this.onGetTeamFolderFileList(this.in_root?'':this.curr_folder.uuid);
      }catch(e){
        console.log('err-create-normal-file',e);
        this.$layer.msg(e.msg);
      }
    },
    onFolderDelete({uuid}){
      this.$DModal.confirm({
        content: '删除文件夹会同时删除文件夹下的所有文件且不可恢复，是否继续？',
        onOK: async () => {
          try{
            const param = {};
            param.team_uuid = this.curr_team.uuid;
            param.directory_uuid = uuid;
            console.log('param==<delete-folder>',param);
            const {code,msg} = await teamFolderDelete(param)
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('操作成功~');
            this.onGetTeamFolderFileList(this.in_root?'':this.curr_folder.uuid);
          }catch(e){
            console.log('err-delete-folder',e);
            this.$layer.msg(e.msg);
          }
        }
      })
    },
    onFolderRename(folder){
      // this.curr_folder = folder;
      this.temp_folder = folder;
      this.is_folder_edit = true;
      this.show_create_folder = true;
    },
    async onGetTeamFolderFileList(id=''){
        try{
            if(!this.curr_team) return;
            const param = {};
            param.team_uuid = this.curr_team.uuid;
            param.parent_directory_uuid = id;
            param.keyword = this.keyword
            const {code,msg,data} = await teamFolderFileList(param)
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.folder_list = data;
        }catch(e){
            console.log('err-get-file-folder-list',e);
            this.$layer.msg(e.msg);
        }
    },
    onDisbandTeam(){
        this.show_team_disband = true;
    },
    onTeamSelect(team){
        this.curr_team = team;
        //> TODO 获取新的文件夹/文件列表,成员列表
        this.onGetTeamFolderFileList();
        this.onGetTeamMemberList();

        if(team.role === '所有者'){
            const {uuid,name,image,description} = this.curr_team;
            this.setting_form = {uuid,name,image,description};
        }else{
            this.setting_form = {
                uuid:'',
                name:'',
                image:'',
                description:''
            }
        }
    },
    onMemberAlias(member){
        this.current_member_id = member.user_id;
        this.current_member_alias = member.name_alias || member.nickname;
        this.show_member_alias = true;
    },
    onMemberRemove(member_id){
        this.current_member_id = member_id;
        this.show_remove_member = true;
    },
    onMemberChat(member) {
      let user = {
        id: member.user_id,
        nickname: member.nickname,
        avatar: member.avatar
      };
      this.$refs["chat"].showChat(null, user);
    },
    async onGetTeamMemberList(){
        try{
            const param = {};
            param.uuid = this.curr_team.uuid;
            this.member_keyword ? param.keyword = this.member_keyword : null;
            const {code,msg,data} = await teamMemberList(param);
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            console.log('data',data);
            this.member_list = data;
        }catch(e){
            console.log('err-member-list',e);
            this.$layer.msg(e.msg);
        }
    },
    async onUpdateTeam(){
        try{
            const {code,msg} = await updateTeam(this.setting_form);
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('团队设置更新成功');
            this.onGetTeamList();
        }catch(e){
            console.log('err-update-team',e);
            this.$layer.msg(e.msg);
        }
    },
    async onQuitTeam(team){
        try{
            if(team.role === '所有者'){
                this.$layer.msg('团队所有者无法直接退出团队，若有需要请在团队设置中解散团队');
                return;
            }
            const {code,msg} = await quitTeam({uuid:team.uuid});
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.$layer.msg('操作成功~');
            this.onGetTeamList();
            this.onGetTeamMemberList();
        }catch(e){
            console.log('err-quit-team',e);
            this.$layer.msg(e.msg);
        }
    },
    async onGetTeamList(){
        try{
            const {code,msg,data} = await teamList();
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            if(this.curr_tab !== 'settings'){
                this.curr_tab = 'files';
            }
            console.log('data-team-list',data);
            if(!data.length){
                this.team_list = [];
                this.curr_team = {};
                return;
            }
            this.team_list = data;
            let curr_team = data.filter((item)=>item.role === '所有者')[0];
            if(!curr_team){
                curr_team = data[0];
            }
            this.curr_team = curr_team;
            const {uuid,name,image,description} = curr_team;
            if(curr_team.role === '所有者'){
                this.setting_form = {uuid,name,image,description};
            }
        }catch(e){
            console.log('err-team-list',e);
        }
    },
    async onFolderClick(folder) {
      console.log("folder", folder);
      if(this.in_root){
        await this.$store.dispatch('clearBreadcrumbs');
      }
      await this.$store.dispatch('setBreadcrumbs',folder);
      this.folder_list = [];
      if(folder.uuid == '-1'){
        this.in_root = true;
        this.curr_folder = {};
        this.onGetTeamFolderFileList();
      }else{
        this.curr_folder = folder;
        this.onGetTeamFolderFileList(folder.uuid);
        this.in_root = false;
      }
    },
    onChangeTab(tab) {
      if (!tab) return;
      this.curr_tab = tab;
      if(tab === 'members'){
        this.onGetTeamMemberList();
      }
      this.in_root = true;
      this.temp_file = {};
      this.curr_folder = {};
      this.curr_file = {};
      if(tab === 'files'){
        this.onGetTeamFolderFileList();
      }
    },
    async onCreateClose(e) {
        console.log('e-close-create',e);
        const {refresh} = e;
        if(refresh){
            this.curr_tab = 'files';
            await this.onGetTeamList();
            this.onGetTeamFolderFileList();
        }
        console.log("关闭创建团队弹窗");
        this.show_create_team = false;
    },
    async onUploadTeamLogo(file) {
      const url = await uploadFileToOSS(file, "template");
      if (!url) {
        this.$layer.msg("上传失败,请重试");
        return;
      }
      this.setting_form.image = url;
      this.onUpdateTeam();
    },
  },
};
</script>
<style lang="scss" scoped>
.team {
  width: 100%;
  height:100%;
  display: flex;
  align-items: center;
  user-select: none;
  padding-left: 30px;
  padding-right: 100px;
  margin-bottom:80px;
  .empty {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .create-team {
      width: 160px;
      height: 46px;
      line-height: 46px;
      background: #ff5967;
      color: #ffffff;
      text-align: center;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;
      margin-top: 50px;
    }
  }
  .team-container {
    width: 100%;
    height: 100%;
    padding-top: 28px;
    display: flex;
    flex-direction: column;
    .team-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 13px;
      border-bottom: 1px solid #e8e8eb;
      .top-left {
        display: flex;
        column-gap: 16px;
        width:calc(100% - 330px);
        .team-logo {
          width: 60px;
          height: 60px;
          border-radius: 6px;
          background: #e9f1ff;
          object-fit: cover;
        }
        .team-info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          row-gap: 10px;
          flex:1;
          width: calc(100% - 60px);
          .team-name-box {
            display: flex;
            align-items: center;
            column-gap: 9px;
            .team-name {
              color: #333333;
              font-size: 18px;
              font-weight: bold;
            }
            .team-tag {
              width: fit-content;
              height: 20px;
              background: #f3f4f6;
              border-radius: 10px;
              color: #666666;
              font-size: 12px;
              padding: 0 8px;
              line-height: 20px;
              text-align: center;
            }
            ::v-deep .ivu-poptip-body {
              padding: 0;
            }
            .team-list-container {
              width: 448px;
              border-radius: 10px;
              background: #ffffff;
              // border:1px solid #e0e0e0;
              // box-shadow:0px 2px 16px 2px #e0e0e0;
              .list-top {
                width: 100%;
                display: flex;
                flex-direction: column;
                .list-item {
                  width: 100%;
                  padding: 26px 20px;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .item-team {
                    display: flex;
                    align-items: center;
                    column-gap: 10px;
                    width:calc(100% - 30px);
                    .item-team-logo {
                      width: 42px;
                      height: 42px;
                      border-radius: 6px;
                      background: #e9f1ff;
                    }
                    .item-team-info {
                      flex:1;
                      display: flex;
                      flex-direction: column;
                      max-width:calc(100% - 52px);
                      .item-team-name-box {
                        display: flex;
                        align-items: center;
                        column-gap: 9px;
                        // width:100%;
                        .item-team-name {
                          color: #333333;
                          font-size: 18px;
                          font-weight: bold;
                        }
                        .item-team-tag {
                          width: fit-content;
                          height: 20px;
                          background: #f3f4f6;
                          border-radius: 10px;
                          color: #666666;
                          font-size: 12px;
                          padding: 0 8px;
                          line-height: 20px;
                          text-align: center;
                        }
                      }
                      .item-team-desc {
                        color: #999999;
                        font-size: 12px;
                        width:fit-content;
                        max-width:100%;
                        flex:1;
                        text-overflow: ellipsis;
                        overflow:hidden;
                        white-space:nowrap;
                      }
                    }
                  }
                  .item-selected {
                    color: #f75664;
                    font-size: 24px;
                    font-weight: bold;
                  }
                  .item-more {
                    background: #e2e5ea;
                    border-radius: 3px;
                    width: 22px;
                    height: 22px;
                    display: none;
                    align-items: center;
                    justify-content: center;
                    .more-list {
                      display: flex;
                      flex-direction: column;
                      .more-item {
                        width: 100%;
                        color: #ff5967;
                        padding: 15px 0 15px 20px;
                        cursor: pointer;
                        &.disabled{
                            cursor:not-allowed;
                            color:#999999;
                        }
                      }
                    }
                  }
                  &:hover {
                    background: #f7f7f7;
                    .item-selected {
                      display: none;
                    }
                    .item-more {
                      display: flex;
                    }
                  }
                }
              }
              .list-bottom {
                width: 100%;
                border-top: 1px solid #e0e0e0;
                padding: 20px;
                .bottom-btn {
                  display: flex;
                  align-items: center;
                  color: #333333;
                  font-size: 16px;
                  cursor: pointer;
                }
              }
            }
          }
          .team-desc {
            color: #999999;
            font-size: 12px;
            // flex:1;
            width:100%;
            white-space:nowrap;
            text-overflow: ellipsis;
            overflow:hidden;
            word-wrap:break-word;
          }
        }
      }
      .top-right {
        width: 300px;
        height: 50px;
        display: flex;
        align-items: center;
        background: #f3f4f6;
        border-radius: 25px;
        padding: 0 20px;
        input {
          background: transparent;
          border: none;
          outline: none;
          flex: 1;
        }
      }
    }
    .team-menu {
      width: 100%;
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .menu-tabs {
        display: flex;
        align-items: center;
        column-gap: 40px;
        .menu-item {
          color: #999999;
          font-size: 16px;
          font-weight: 400;
          padding-bottom: 9px;
          cursor: pointer;
          &:hover,
          &.active {
            color: #333333;
            font-weight: 500;
            position: relative;
            &::after {
              content: "";
              width: 32px;
              height: 4px;
              display: block;
              position: absolute;
              bottom: 0;
              left: 0;
              background: #ff5967;
              border-radius: 2px;
            }
          }
        }
      }

      .bread-crumb{
        display:flex;
        align-items:center;

      }

      .menu-actions {
        display: flex;
        align-items: center;
        column-gap: 10px;
        .add-member,
        .add-file {
          width: 110px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
          column-gap: 4px;
        }
        .add-member {
          background: #ffffff;
          border: 1px solid #dedee0;
          color: #4d4d4d;
          img {
            width: 20px;
            height: 20px;
          }
          &.members-style {
            background: #ff5967;
            color: #ffffff;
            border: none;
          }
        }
        .add-file {
          background: #ff5967;
          color: #ffffff;
        }
        .add-menu-list {
          width: 100%;
          display: flex;
          flex-direction: column;
          ::v-deep .ivu-upload{
            width:100%;
          }
          .add-menu-item {
            width: 100%;
            color: #333333;
            font-size: 14px;
            padding: 17px 9px;
            cursor: pointer;
            border-radius: 3px;
            &:hover {
              background: #f7f7f7;
            }
          }
        }
      }
    }
    .team-folder-title {
      color: #333333;
      font-size: 16px;
      margin: 30px 0 17px 0;
    }
    .team-folder-list {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 15px;
      flex-wrap: wrap;
      .team-folder-item {
        width: 204px;
        height: 100px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        .folder-actions {
          position: absolute;
          top: 10px;
          right: 10px;
          display: none;
          .folder-action-menu {
            width: 100%;
            display: flex;
            flex-direction: column;
            .folder-action-item {
              width: 100%;
              padding: 10px 18px;
              display: flex;
              align-items: center;
              column-gap: 12px;
              color: #333333;
              font-size: 14px;
              &:hover {
                background: #f7f7f7;
              }
              .folder-action-icon {
                width: 22px;
                height: 22px;
              }
              .item-selected {
                color: #f75664;
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }
        &:hover {
          background: #f7f7f7;
          .folder-actions {
            display: block;
          }
        }
        .folder-container {
          width: 100%;
          height: 100%;
          padding: 0 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 11px;
          .folder-icon {
            width: 60px;
            height: 60px;
          }
          .folder-info {
            display: flex;
            flex-direction: column;
            flex:1;
            row-gap: 10px;
            .folder-name {
              color: #333333;
              font-size: 14px;
            }
            .folder-count {
              color: #999999;
              font-size: 12px;
            }
          }
        }
      }
    }
    .team-resource-title {
      color: #333333;
      font-size: 16px;
      margin-top: 40px;
    }
    .team-resource-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 19px;
      column-gap: 15px;
      row-gap: 30px;
      .file-item {
        width: 204px;
        display: flex;
        flex-direction: column;
        row-gap: 15px;
        cursor: pointer;
        .icon-cover-box {
          width: 100%;
          height: 204px;
          background: #f7f7f7;
          border-radius: 10px;
          border: 1px solid #ebebeb;
          // overflow:hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .cover-img {
            width: 100%;
            height: auto;
            max-height:100%;
            object-fit: contain;
          }
          .cover-icon{
            width:84px;
            height:100px;
            object-fit:contain;
          }
          .file-more {
            display: none;
            position: absolute;
            top: 0;
            right: 0;
            .more-btn {
              background: url("../../assets/images/team/icon-team-file-more.png");
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
              width: 30px;
              height: 30px;
            }
            .more-action-menu {
              width: 100%;
              display: flex;
              flex-direction: column;
              .action-item {
                width: 100%;
                padding: 10px 18px;
                display: flex;
                align-items: center;
                column-gap: 12px;
                color: #333333;
                font-size: 14px;
                &:hover {
                  background: #f7f7f7;
                }
                .action-icon {
                  width: 22px;
                  height: 22px;
                }
              }
              .action-folder-list {
                width: 100%;
                display: flex;
                flex-direction: column;
                .action-folder-item {
                  width: 100%;
                  padding: 15px 18px;
                  display: flex;
                  align-items: center;
                  column-gap: 8px;
                  cursor: pointer;
                  color: #333333;
                  font-size: 14px;
                  border-radius: 3px;
                  &:hover {
                    background: #f7f7f7;
                  }
                  img {
                    width: 22px;
                    height: 22px;
                  }
                }
              }
            }
          }
          &:hover {
            .file-more {
              display: block;
            }
          }
        }
        .file-name {
          width: 100%;
          text-align: center;
        }
      }
    }
    .folder-empty-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 10px;
      .folder-files-add-btn {
        width: 80px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 7px;
        color: #ffffff;
        background: #ff5967;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
      }
      .import-btn {
        width: 160px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #ffffff;
        background: #ff5967;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
      }
    }
    .member-top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 26px;
      .member-title {
        color: #333333;
        font-size: 16px;
      }
      .member-search {
        flex: 1;
        max-width: 216px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #e4e4e5;
        background: #ffffff;
        padding: 0 0 0 10px;
        input {
          border: none;
          outline: none;
          flex: 1;
          height: 100%;
          line-height: 32px;
          padding-right: 10px;
        }
      }
    }
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-top: 20px;
      text-align: center;
      thead tr {
        background: #edeff2;
        height: 46px;
        th {
          color: #808080;
        }
      }
      tbody {
        width: 100%;
        .data-tr{
            border-bottom:1px solid #ebebeb;
            height:70px;
            align-items:center;
            color:#666666;
            font-size:14px;
            &:hover{
                background:#f5f5f5;
            }
            .member-info{
                display:flex;
                align-items:center;
                // justify-content:center;
                column-gap:9px;
                margin-left:59px;
                // width:100%;
                .member-avatar{
                    width:38px;
                    height:38px;
                    border:1px solid #ebebeb;
                    border-radius:50%;
                }
                .member-nick-mobile{
                    display:flex;
                    flex-direction:column;
                    align-items:start;
                    row-gap:8px;
                    .member-nick{
                        display:flex;
                        align-items:center;
                        column-gap:5px;
                        color:#333333;
                        font-size:14px;
                        font-weight: 500;
                        .owner-tag{
                            width:26px;
                            height:18px;
                            font-size:12px;
                            border-radius:9px;
                            color:#ff5967;
                            background:rgba(255,89,103,0.2);
                        }
                    }
                    .member-mobile{
                        color:#666666;
                        font-size:12px;
                    }
                }
            }
            .operation-col{
                display:flex;
                align-items:center;
                column-gap:10px;
                justify-content:center;
                font-size:14px;
                .line{
                    color:#cccccc;
                }
                .btn{
                    display:flex;
                    align-items:center;
                    column-gap:6px;
                    color:#666666;
                    cursor:pointer;
                    .btn-icon{
                        width:18px;
                        height:18px;
                    }
                    &:hover{
                        color:#ff5967;
                    }
                }
                .chat{
                  justify-content: center;
                  width: 78px;
                  height: 32px;
                  border-radius: 4px;
                  border: 1px solid #E0E0E0;
                   &:hover{
                      border: 1px solid #FF5967;
                      .chat-icon{
                        background-image: url(../..//assets/images/team/icon-team-member-chat-active.png);
                      } 
                  }
                  .chat-icon{
                    background-image: url(../..//assets/images/team/icon-team-member-chat.png);
                    background-size: cover;
                    background-repeat: no-repeat;
                    width:18px;
                    height:18px;
                  }
              }
            }
        }
      }
    }
    .team-settings{
        display:flex;
        flex-direction:column;
        width:720px;
        .create-form{
            margin-top:30px;
            .label{
                color:#1a1a1a;
                font-size:14px;
            }
           .upload-team-logo{
             width:100%;
             height:100px;
             display:flex;
             column-gap:24px;
             .logo-container{
                width:100px;
                height:100%;
                border-radius:6px;
                background:#e9f1ff;
                object-fit:cover;
             }
             .upload-btn{
                display:flex;
                align-items:start;
                justify-content:center;
                flex-direction:column;
                .btn{
                    width:110px;
                    height:36px;
                    background:#ebebeb;
                    border-radius:5px;
                    color:#333333;
                    font-size:14px;
                    line-height:36px;
                    text-align:center;
                    cursor:pointer;
                }
                .tips{
                    color:#b3b3b3;
                    font-size:12px;
                }
             }
           }
        }
        .btn-box{
            width:100%;
            display:flex;
            justify-content:start;
            align-items:start;
            flex-direction:column;
            .btn-label{
                color:#1a1a1a;
                font-size:14px;
                margin-bottom:20px;
            }
            .confirm-btn{
                width:110px;
                height:36px;
                line-height:36px;
                text-align:center;
                color:#ffffff;
                border-radius:5px;
                background:#fa3d5a;
                cursor:pointer;
            }
            .btn-desc{
                margin-top:15px;
                color:#b3b3b3;
                font-size:14px;
            }
        }
    }
  }
}
</style>
